import { createReducer } from "@reduxjs/toolkit";
import { IBulkMarketplaceList, IBulkSummaryList, IDetailTncPrivacyPolice, IMarketplaceList } from "app/interfaces/marketplace/marketplace.interface";
import { ICommonState } from "app/interfaces/reducer-interface/common.interface";
import {
    getMarketplaceListAction,
    marketplaceDownloadFactsheetAction,
    marketplaceSetFactsheetAction,
    resetMarketplaceFactsheetAction,
    resetMarketplaceListAction,
    setMarketplaceListAction,
	getTNCPrivacyPolicy,
	setTNCPrivacyPolicy,
    getBulkMarketplaceList,
    setBulkMarketplaceList,
    getBulkSummaryList,
    setBulkSummaryList,
    getBulkLoanNumberAction,
    setBulkLoanNumberAction
} from "../actions/MarketplaceListAction";
import { IPagination } from "./PortofolioReducer";
import { IBulkLoanNumberResponse } from "../actions/FundingAction";

export interface IMarketplaceListState extends ICommonState {
    marketplaceList: IMarketplaceList[];
    bulkMarketplaceList: IBulkMarketplaceList[];
    bulkSummaryList: IBulkSummaryList[];
	dataTNCPrivacyPolicy: IDetailTncPrivacyPolice[];
    pagination: IPagination;
    bulkPagination: IPagination;
    bulkSummaryPagination: IPagination;
    factsheetBase64: Blob | undefined;
    bulkLoanNumber: IBulkLoanNumberResponse[];
    isBulkFunding: boolean;
}

const paginationInit: IPagination = {
	totalData: 0,
	totalPage: 0,
	page: 1,
};

const initialState: IMarketplaceListState = {
    marketplaceList: [],
	dataTNCPrivacyPolicy: [],
    loading: true,
    error: '',
	message: '',
    pagination: paginationInit,
    factsheetBase64: undefined,
    bulkMarketplaceList: [],
    bulkPagination: paginationInit,
    bulkSummaryList: [],
    bulkSummaryPagination: paginationInit,
    bulkLoanNumber: [],
    isBulkFunding: false,
};

const marketplaceListReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(getMarketplaceListAction, (state) => ({
            ...state,
            loading: true,
        }))
        .addCase(setMarketplaceListAction, (state, action) => ({
            ...state,
            loading: false,
            marketplaceList: action.payload.marketplaceList,
            pagination: action.payload.pagination
        }))
        .addCase(resetMarketplaceListAction, (state) => ({
            ...state,
            loading: false,
            marketplaceList: [],
            pagination: paginationInit
        }))
        .addCase(marketplaceDownloadFactsheetAction, (state) => ({
			...state
		}))
		.addCase(marketplaceSetFactsheetAction, (state, action) => ({
			...state,
			factsheetBase64: action.payload.base64Image
		}))
        .addCase(resetMarketplaceFactsheetAction, (state) => ({
			...state,
			factsheetBase64: undefined
		}))
		.addCase(getTNCPrivacyPolicy, (state) => ({
			...state,
			dataTNCPrivacyPolicy: []
		}))
		.addCase(setTNCPrivacyPolicy, (state, { payload }) => ({
			...state,
			dataTNCPrivacyPolicy: payload
		}))
        .addCase(getBulkMarketplaceList, (state) => ({
            ...state,
            loading: true,
        }))
        .addCase(setBulkMarketplaceList, (state, action) => ({
            ...state,
            loading: false,
            bulkMarketplaceList: action.payload.bulkList,
            bulkPagination: action.payload.pagination,
            isBulkFunding: action.payload.isBulkFunding
        }))
        .addCase(getBulkSummaryList, (state) => ({
            ...state,
            loading: true,
        }))
        .addCase(setBulkSummaryList, (state, action) => ({
            ...state,
            loading: false,
            bulkSummaryList: action.payload.bulkSummaryList,
            bulkSummaryPagination: action.payload.pagination
        }))
        .addCase(getBulkLoanNumberAction, (state) => ({
			...state,
			loading: true,
		}))
		.addCase(setBulkLoanNumberAction, (state, action) => ({
			...state,
			loading: false,
			bulkLoanNumber: action.payload,
		}))
        .addDefaultCase((state) => state);
});

export default marketplaceListReducer;
